var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-element-properties-panel vscroll-wrap vscroll-scroll",attrs:{"data-test-id":"element-properties-panel"}},[(_vm.elementIsActive)?[_c('Titlebar'),_c('TabsAndControls')]:[_c('BlankSidebarContent')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }